(function () {
'use strict';

// 2017年 10月数据
const defaultTime = 1514764800000;
const base = {
  data: {
    minute: 860070140,
    voice: 11199914451,
    people: 61319487
  },
  rate: {
    minute: 1.07,
    voice: 1.075,
    people: 1.06
  }
};

const calculate = (name) => {
  return base.data[name] * Math.pow(base.rate[name], (new Date().getTime() - defaultTime) / 2592000000);
};

let minute = {
  start: calculate('minute'),
  end: calculate('minute')
};
let voice = {
  start: calculate('voice'),
  end: calculate('voice')
};
let people = {
  start: calculate('people'),
  end: calculate('people')
};
const options = {
  useEasing: true,
  useGrouping: true,
  separator: ',',
  decimal: '.',
  prefix: '',
  suffix: ''
};
const minuteFunc = () => {
  const minuteCount = new window.countUp('minute', minute.start, minute.end, 0, 2, options);
  minuteCount.start();
  minute.start = minute.end;
  minute.end = calculate('minute');
};
minuteFunc();
setInterval(minuteFunc, 3000);

const voiceFunc = () => {
  const voiceCount = new window.countUp('voice', voice.start, voice.end, 0, 3, options);
  voiceCount.start();
  voice.start = voice.end;
  voice.end = calculate('voice');
};
voiceFunc();
setInterval(voiceFunc, 4000);

const peopleFunc = () => {
  const peopleCount = new window.countUp('people', people.start, people.end, 0, 2, options);
  peopleCount.start();
  people.start = people.end;
  people.end = calculate('people');
};
peopleFunc();
setInterval(peopleFunc, 3000);

function formatDate(timeStr, dateSeparator = '-', timeSeparator = ':') {
  const date = new Date(timeStr);
  const year = date.getFullYear(); // 获取完整的年份(4位,1970)
  const month = date.getMonth() + 1; // 获取月份(0-11,0代表1月,用的时候记得加上1)
  const day = date.getDate(); // 获取日(1-31)
  const hour = date.getHours(); // 获取小时数(0-23)
  const minute = date.getMinutes(); // 获取分钟数(0-59)
  // const seconds = date.getSeconds(); // 获取秒数(0-59)

  const Y = year;
  const M = month > 9 ? month : '0' + month;
  const D = day > 9 ? day : '0' + day;
  const h = hour > 9 ? hour : '0' + hour;
  const m = minute > 9 ? minute : '0' + minute;
  // const s = seconds > 9 ? seconds : '0' + seconds;

  return `${Y}${dateSeparator}${M}${dateSeparator}${D} ${h}${timeSeparator}${m}`;
}

const time = document.getElementById('time');

setInterval(() => {
  time.innerText = formatDate(new Date(), '.');
}, 1000);

function launchFullscreen (element) {
  if(element.requestFullscreen) {
    element.requestFullscreen();
  } else if(element.mozRequestFullScreen) {
    element.mozRequestFullScreen();
  } else if(element.msRequestFullscreen){
    element.msRequestFullscreen();
  } else if(element.webkitRequestFullscreen) {
    element.webkitRequestFullScreen();
  }
}
document.body.addEventListener('click', function () {
  launchFullscreen(document.getElementById('board'));
});

}());
